/*
 *
 * Package: `@dbh/navbar-theme`.
 *
 */const THEME_KEY_NAVBAR="navbar";const modifyNavbarTheme=a=>{let{spacing:{sp10:b},colors:{white:c}}=a;return {[THEME_KEY_NAVBAR]:{height:b,backgroundColor:c}}};

export { THEME_KEY_NAVBAR, modifyNavbarTheme as default };
